// removed by extract-text-webpack-plugin
module.exports = {"content":"D-X2uKL7dy-H3zcZuWWRc","actionBar":"_1KozFhTEgOx7LzuJgwjGz3","searchBox":"_2w5woMkfOIDpl8zeAxBGhR","actionBox":"_2xpZgxxLbbvXUOTwUAtlth","orderTitle":"_30rCtVHADFHwanp8-rgFsa","cardBox":"_3ks7s0RqOyCvfvOADDUJNx","fadein":"_1j6FovUTJ-mtCN8Y9rmh0a","exiting":"_1mdVHtoscgeTuccY2W2Bzv","exited":"_26BrkYd3XzC9EPJYO68y1D","table":"_12_LG_bAMWY2zv4mIhykYK","spacer":"_2YaWjQredRsonQuYv3G_s3"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Kits/users.scss
// module id = 630
// module chunks = 0